"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("./fetch");
var version_json_1 = require("./version.json");
var DEFAULT_CONFIG = {
    maxBuffer: 50,
    throttleDuration: 250,
    autoRetry: true,
    autoRetryDuration: 1000,
    enabled: true,
    logToConsole: false,
    errorFormatter: function (err) { return ({
        name: err.name,
        message: err.message,
        stack: err.stack,
    }); },
};
var DEFAULT_LOG_TYPES = [
    'debug',
    'info',
    'warn',
    'error',
];
var Logger = /** @class */ (function () {
    function Logger(config) {
        this._buffer = [];
        this._config = __assign({}, DEFAULT_CONFIG, config);
        this.interceptor = config.interceptor;
    }
    Logger.singleton = function (config) {
        var logTypes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            logTypes[_i - 1] = arguments[_i];
        }
        global.__kersplunkSingleton =
            global.__kersplunkSingleton || Logger.create.apply(Logger, [config].concat(logTypes));
        return global.__kersplunkSingleton;
    };
    Logger.create = function (config) {
        var logTypes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            logTypes[_i - 1] = arguments[_i];
        }
        var logger = new Logger(config);
        var finalLogTypes = logTypes.length
            ? logTypes
            : DEFAULT_LOG_TYPES;
        Object.assign(logger, finalLogTypes.reduce(function (acc, logType) {
            var _a;
            return (__assign({}, acc, (_a = {}, _a[logType] = function (eventName, details) {
                return logger._log(logType, eventName, details);
            }, _a)));
        }, {}));
        return logger;
    };
    Logger.clearSingleton = function () {
        global.__kersplunkSingleton = undefined;
    };
    Logger.prototype.enable = function () {
        this._config.enabled = true;
    };
    Logger.prototype.disable = function () {
        this._config.enabled = false;
    };
    Logger.prototype.flush = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._clearBufferTimeout();
                        if (this._buffer.length === 0) {
                            return [2 /*return*/];
                        }
                        body = this._buffer.join('\n');
                        this._buffer = [];
                        return [4 /*yield*/, this._flushBodyWithRetry(body)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Logger.prototype._buildSplunkMeta = function () {
        var meta = typeof this._config.splunkMeta === 'function'
            ? this._config.splunkMeta()
            : this._config.splunkMeta;
        return __assign({ time: Date.now() / 1000, sourcetype: '_json', source: "kersplunk-" + version_json_1.version }, meta, { fields: __assign({}, (meta && meta.fields), { kersplunk: version_json_1.version }) });
    };
    Logger.prototype._stringify = function (obj) {
        var originalToJSON = Error.prototype.toJSON;
        var errorFormatter = this._config.errorFormatter;
        Error.prototype.toJSON = function () {
            return errorFormatter(this);
        };
        var stringified = JSON.stringify(obj);
        Error.prototype.toJSON = originalToJSON;
        return stringified;
    };
    Logger.prototype._log = function (logType, eventName, details) {
        if (this._config.logToConsole) {
            console.log(logType, eventName, details || ''); // tslint:disable-line no-console
        }
        if (!this._config.enabled) {
            return;
        }
        var event = __assign({ logType: logType,
            eventName: eventName }, (details instanceof Error
            ? this._config.errorFormatter(details)
            : details));
        var finalEvent = this.interceptor ? this.interceptor(event) : event;
        this._buffer = this._buffer.concat([
            this._stringify(__assign({}, this._buildSplunkMeta(), { event: finalEvent })),
        ]);
        this._startOrResetBufferTimeout();
        if (this._buffer.length >= this._config.maxBuffer) {
            this.flush();
        }
    };
    Logger.prototype._flushBodyWithRetry = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch_1.fetch(this._config.splunkUrl, {
                                method: 'POST',
                                headers: { Authorization: "Splunk " + this._config.authToken },
                                body: body,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        if (this._config.autoRetry) {
                            setTimeout(function () { return _this._flushBodyWithRetry(body); }, this._config.autoRetryDuration);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Logger.prototype._startOrResetBufferTimeout = function () {
        var _this = this;
        if (this._bufferTimeout) {
            clearTimeout(this._bufferTimeout);
        }
        this._bufferTimeout = setTimeout(function () { return _this.flush(); }, this._config.throttleDuration);
    };
    Logger.prototype._clearBufferTimeout = function () {
        if (this._bufferTimeout) {
            clearTimeout(this._bufferTimeout);
            this._bufferTimeout = undefined;
        }
    };
    return Logger;
}());
exports.Logger = Logger;
